import React from "react";
import moment from "moment";
import { ELEARNING_WEEKS_DEFAULT } from "../../../constants";

export default class EventTemplateElearning extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dateStart: props.eventDetails && props.eventDetails.start_datetime ? props.eventDetails.start_datetime : null,
            dateEnd: props.eventDetails && props.eventDetails.end_datetime ? props.eventDetails.end_datetime : null,
            timeFromHours: props.eventDetails && props.eventDetails.start_datetime ? moment(props.eventDetails.start_datetime).format("HH") : "00",
            timeFromMinutes: props.eventDetails && props.eventDetails.start_datetime ? moment(props.eventDetails.start_datetime).format("mm") : "00",
            timeToHours: props.eventDetails && props.eventDetails.end_datetime ? moment(props.eventDetails.end_datetime).format("HH") : "00",
            timeToMinutes: props.eventDetails && props.eventDetails.end_datetime ? moment(props.eventDetails.end_datetime).format("mm") : "00",
            editable: props.editable ? props.editable : true,
            template: props.templateUUID,
            course: props.courseUUID,
            trainer: props.trainerUUID,
            errorMessage: "",
            infoNotice: false,
            availableInstructors: [],
            availableLocations: props.availableLocations ? props.availableLocations : [],
            elearningWeeks: props?.elearningWeeks ? parseInt(props.elearningWeeks) : ELEARNING_WEEKS_DEFAULT
        };
    }

    passValuesToParent = (values) => {
        this.props.passValuesToParent({
            uuid: this.props.eventDetails ? this.props.eventDetails.uuid : null,
            trainer: values.trainer,
            course: values.course,
            location: null,
            start_datetime: values.start_datetime,
            end_datetime: values.end_datetime,
            template: values.template,
            event_roles: [
                {
                    template: this.props.templateDetails.roles[0].uuid,
                    instructors: []
                }
            ]
        });
    };

    componentDidUpdate = () => {
        // Build up a list of templates we may check
        let checkTemplates = [];
        let dateEnd = null;
        let dateStart = this.state.dateStart;

        if (this.props.eventTemplates && this.props.allEventDetails) {
            let checkPrereqEvents = this.props.eventTemplates.filter((item) => item.prerequisites.includes(this.props.templateUUID));

            if (checkPrereqEvents.length > 0) {
                checkPrereqEvents.forEach((item) => {
                    checkTemplates.push(item.uuid);
                });
            } else {
                this.props.eventTemplates.forEach((template) => {
                    if (template.type !== "elearning") {
                        checkTemplates.push(template.uuid);
                    }
                });
            }

            let earliestEventDate = null;
            let nonElearningEarliestDate = null;
            let infoNotice = this.state.infoNotice;

            this.props.allEventDetails.forEach((eventDetail) => {
                // No end date specified yet, check if we can copy one of the other moments
                if (checkTemplates.includes(eventDetail.template)) {
                    if (dateStart === null && eventDetail.start_datetime) {
                        dateStart = eventDetail.start_datetime;
                    }
                    if (moment(eventDetail.start_datetime) < moment(dateStart) && moment(eventDetail.start_datetime) > moment()) {
                        dateStart = eventDetail.start_datetime;
                    }
                    if (!checkPrereqEvents && dateEnd === null) {
                        dateEnd = eventDetail.start_datetime;
                    }
                    if (dateEnd === null && eventDetail.start_datetime) {
                        dateEnd = eventDetail.start_datetime;
                    }
                    if (moment(eventDetail.start_datetime) < moment(dateEnd) && moment(eventDetail.start_datetime) > moment()) {
                        dateEnd = eventDetail.start_datetime;
                    }

                    // Update the check date for events
                    if (earliestEventDate === null && eventDetail.start_datetime) {
                        earliestEventDate = moment(eventDetail.start_datetime);
                    }
                    if (moment(eventDetail.start_datetime) < earliestEventDate) {
                        earliestEventDate = moment(eventDetail.start_datetime);
                    }
                }

                // This only takes into account types that are not elearning
                let template = this.props.eventTemplates.find((temp) => temp.uuid == eventDetail.template);
                if (template.type !== "elearning") {
                    if (nonElearningEarliestDate === null && eventDetail.start_datetime) {
                        nonElearningEarliestDate = moment(eventDetail.start_datetime);
                    }
                    if (moment(eventDetail.start_datetime) < nonElearningEarliestDate) {
                        nonElearningEarliestDate = moment(eventDetail.start_datetime);
                    }
                }
            });

            // Subtract weeks (4, previously 6) from the first time we can find from the above events
            if (earliestEventDate !== null) {
                let fourWeeksFromNow = moment().add(4, "weeks");
                let checkStartDate = earliestEventDate.clone().subtract(4, "weeks");
                const courseCreationDate = moment(this.props.course.created);

                // When the practical test moment is 4 weeks or more in the future
                if (earliestEventDate.isSameOrAfter(fourWeeksFromNow)) {
                    // Set e-learning start date to 4 weeks before practical test moment
                    dateStart = checkStartDate.format("YYYY-MM-DD") + "T00:00:00";
                }
                // When the practical test moment is within 4 weeks or less in the future
                else {
                    // Set e-learning start date to the day of course creation
                    dateStart = courseCreationDate.format("YYYY-MM-DD") + "T00:00:00";
                }
            }

            if (!dateEnd && nonElearningEarliestDate) {
                dateEnd = nonElearningEarliestDate.format("YYYY-MM-DD") + "T00:00:00";
            }

            if (dateStart !== this.state.dateStart || dateEnd !== this.state.dateEnd) {
                this.setState({
                    dateEnd,
                    dateStart,
                    infoNotice
                });
                this.passValuesToParent({
                    ...this.state,
                    dateStart,
                    dateEnd,
                    end_datetime: dateEnd,
                    start_datetime: dateStart
                });
            }
        }
    };

    render = () => {
        let title = [];
        let child = false;

        if (this.props.hideTitle !== true) {
            title.push(
                <div className="col-12" key="title">
                    <h2 className="h1">{this.props.templateDetails.name}</h2>
                </div>
            );
        }

        let prerequiredEvent = null;
        let notificationLine = ["De e-learning moet afgerond zijn voor de start van het bijbehorende praktijkmoment."];
        if (this.props.templateUUID) {
            prerequiredEvent = this.props.eventTemplates.filter(
                (item) => item.prerequisites.includes(this.props.templateUUID) && this.props.allEventDetails.find((event) => event.template === item.uuid)
            );

            if (prerequiredEvent.length > 0) {
                notificationLine = [`Deze e-learning moet afgerond zijn voor de start van ${prerequiredEvent.map((item) => item.name).join(" en ")}`];
            }
        }

        if (this.state.infoNotice) {
            notificationLine.push(this.state.infoNotice);
        }
        if (this.state.dateStart) {
            notificationLine.push(`De startdatum voor deze e-learning staat op ${moment(this.state.dateStart).format("D MMMM YYYY")}.`);
        }
        if (this.state.dateEnd) {
            notificationLine.push(`De einddatum voor deze e-learning staat op ${moment(this.state.dateEnd).format("D MMMM YYYY")}.`);
        }

        return (
            <div>
                <div className="row">
                    {title}
                    <div className="col-11">
                        <ul>
                            {notificationLine.map((item) => {
                                return <li key={Math.random()}>{item}</li>;
                            })}
                        </ul>
                    </div>
                </div>
                <br />
            </div>
        );
    };
}
